import React from 'react';
import styles from './index.module.css';

export default function CodeOfConduct() {
  return (
    <div className={`container-fluid ${styles.nopadding} marg-top-for-transparent-header`}>
      <div className='row'>
        <div className='col-sm-1'></div>
        <div className='col-sm-10'>
          <section className={styles.termsSection}>
            <h1>
              <b>Mentee Code of Conduct</b>
            </h1>
            <p>PatientPartner's MentorConnect program, a peer mentorship program for Treatment Support</p>
            <p>
              <b>1. What This Program Is (and Isn't)</b>
            </p>
            <ol>
              <li>This program provides peer support and shared experiences.</li>
              <li>
                Your mentor is not part of a healthcare team and cannot provide medical advice, change your treatment,
                or make decisions about your health condition or treatment.
              </li>
              <li>
                Emergencies: If you think you are having a medical emergency or are in danger, call 911 (or local
                emergency services) and contact your healthcare team.
              </li>
            </ol>
            <p>
              <b>2. Respectful Communication</b>
            </p>
            <p>You agree to communicate respectfully. You will not:</p>
            <ol>
              <li>Harass, threaten, stalk, intimidate, or bully anyone.</li>
              <li>Use hate speech or discriminatory language.</li>
              <li>Send sexually explicit content or unwanted sexual messages.</li>
              <li>Share violent, graphic, or otherwise inappropriate content.</li>
            </ol>
            <p>
              <b>3. Privacy and Confidentiality</b>
            </p>
            <p>To protect you and others:</p>
            <ol>
              <li>
                Do not share the mentor's personal information (or any other participant's information) outside the
                program.
              </li>
              <li>
                Do not ask for or share highly sensitive identifiers (e.g., Social Security numbers, insurance IDs, full
                home address).
              </li>
              <li>Do not record, screenshot, copy, or forward messages outside the platform.</li>
            </ol>
            <p>
              <b>4. Health and Program Boundaries</b>
            </p>
            <ol>
              <li>
                Do not ask your mentor to interpret test results, recommend treatments, adjust device/drug dosing, or
                provide medical opinions.
              </li>
              <li>
                For treatment-specific questions (appointments, eligibility, procedures, adverse events, consent,
                compensation), contact your healthcare team.
              </li>
              <li>You may discuss your experience, but you are never required to share personal health information.</li>
            </ol>
            <p>
              <b>5. Safety and Reporting</b>
            </p>
            <p>
              If you share any of the following, program staff may escalate it to the appropriate healthcare team so
              they can follow up:
            </p>
            <ol>
              <li>Thoughts of self-harm or harm to others, or threats of violence</li>
              <li>Severe symptoms or urgent safety concerns</li>
              <li>Possible side effects/adverse events or product/device/drug problems</li>
              <li>Allegations of abuse, exploitation, or illegal activity</li>
            </ol>
            <p>
              <b>6. No Solicitation or Incentives</b>
            </p>
            <ol>
              <li>Do not offer or request money, gifts, services, or incentives from mentors or other participants.</li>
              <li>
                Do not promote outside products, services, fundraising, or recruitment for other therapies or programs.
              </li>
            </ol>
            <p>
              <b>7. Use of the Platform</b>
            </p>
            <p>Use the platform only for program-related conversations.</p>
            <ol>
              <li>Do not impersonate others or provide false information.</li>
              <li>Follow any scheduling and messaging rules provided by the program.</li>
            </ol>
            <p>
              <b>8. If Something Feels Wrong</b>
            </p>
            <p>You can stop a conversation at any time. If you feel uncomfortable, you may:</p>
            <ol>
              <li>Use "block" or "report" tools in the platform (if available), and/or</li>
              <li>
                Contact the Program Administrator at:{' '}
                <a href='mailto:contact@patientpartner.com'>contact@patientpartner.com</a>
              </li>
            </ol>
            <p>
              <b>9. Consequences</b>
            </p>
            <p>
              To protect participants, the program may pause or end your participation if you violate this Code of
              Conduct.
            </p>
            <p>
              <b>10. Acknowledgment</b>
            </p>
            <p>
              By checking the box during account registration, I confirm that I have read, understand, and agree to be
              bound by this Mentee Code of Conduct. I acknowledge that compliance with this Code of Conduct is a
              condition of participation in the program.
            </p>
            <p>
              <b>Last updated: December, 2025</b>
            </p>
          </section>
        </div>
        <div className='col-sm-1'></div>
      </div>
    </div>
  );
}
